import { Pipe, PipeTransform } from '@angular/core';
import { Learning_Type } from '@app/enums/learning-type.enum';

@Pipe({
  name: 'formatDuration',
  standalone: false,
})
export class FormatDurationPipe implements PipeTransform {
  /**
   * Return formatted duration string
   * @param learningType - learning type to transform formatted duration string
   * @param courseDuration - courseDuration in days for ILT/VILT courses
   * @param courseDurationMins - courseDurationMins in mins for eLearning courses
   * @returns formatted duration string
   */
  transform(learningType: string, courseDuration: number, courseDurationMins: number): string {
    switch (learningType) {
      case Learning_Type.WEBINAR:
      case Learning_Type.QUICK_LEARNING:
      case Learning_Type.E_LEARNING:
        if (courseDurationMins) {
          return courseDurationMins + ' mins';
        } else {
          return '';
        }
      case Learning_Type.CERTIFICATION_EXAM:
        return '';
      case Learning_Type.SELF_STUDY:
        return '';
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.VIRTUAL:
      case Learning_Type.IN_PERSON:
      case Learning_Type.WORKSHOP:
        if (courseDuration) {
          if (courseDuration > 1) {
            return courseDuration + ' days';
          } else {
            return courseDuration + ' day';
          }
        } else {
          return '';
        }
      default:
        return '';
    }
  }
}
